import { render, staticRenderFns } from "./jump.vue?vue&type=template&id=cf9018e6&scoped=true&"
import script from "./jump.vue?vue&type=script&lang=js&"
export * from "./jump.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9018e6",
  null
  
)

export default component.exports